import { Link } from '@tanstack/react-router';
import { useTranslation } from '@eon/i18n';
import { Button, Card, CardContent, PageHeader } from '@eon/ui';
import { ShieldX } from 'lucide-react';

export function ForbiddenPage() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('errors.forbidden')} />
      <Card className="max-w-lg">
        <CardContent className="flex flex-col items-start gap-4 p-6">
          <div className="flex items-center gap-3">
            <ShieldX className="text-destructive h-8 w-8" />
            <p className="text-muted-foreground text-sm">{t('errors.forbiddenDetail')}</p>
          </div>
          <Button asChild variant="outline">
            <Link to="/">{t('nav.dashboard')}</Link>
          </Button>
        </CardContent>
      </Card>
    </>
  );
}
